export const BUTTONS = [
    {
        title: 'IT C-level тут',
        href: 'https://t.me/sthhb',
        icon: 'tg'
    }
]